import React from "react";
import { inject, observer } from "mobx-react";



const GTGTherm1000 = (props) => {

  const { gtgGoal, gtgProgress } = props.overlayStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const bgColor = urlParams.get('bgColor');

  console.log(gtgGoal);
  return (

    <div className="meter">
      <div className="meter__wrap">

        <div className={
          'meter__sections first' +
          `${gtgProgress < 25 ? ' active' : gtgProgress >= 25 ? ' complete' : ''}`
        }>
          {gtgProgress >= 25 ? <div className="border" /> : ''}
          <div className="icon" />
          <p className="text">$250 - provide meals for a week</p>
        </div>

        <div className={
          'meter__sections second' +
          `${gtgProgress >= 25 && gtgProgress < 50 ? ' active' : gtgProgress >= 50 ? ' complete' : ''}`
        }>
          {gtgProgress >= 50 ? <div className="border" /> : ''}
          <span className="icon" />
          <p className="text">$500 - one platelet transfusion</p>
        </div>

        <div className={
          'meter__sections third' +
          `${gtgProgress >= 50 && gtgProgress < 75 ? ' active' : gtgProgress >= 75 ? ' complete' : ''}`
        }>
          {gtgProgress >= 75 ? <div className="border" /> : ''}
          <span className="icon" />
          <p className="text">$750 - three days of oxygen</p>
        </div>


        <div className={
          'meter__sections fourth' +
          `${gtgProgress >= 75 && gtgProgress < 100 ? ' active' : gtgProgress >= 100 ? ' complete' : ''}`
        }>
          <span className="icon" />
          <p className="text">
            $1000 - necessities for 20 patient families</p>
        </div>
      </div>


      <div className="therm-container" id="therm">

        <div
          id="therm-container__expand"
          className={
            'therm-container__inner ' + `${bgColor}`
          }
          style={{
            width: `
                    ${gtgProgress}%
                  `
          }}
        ></div>
      </div>

    </div>


  );
}

export default inject("overlayStore")(observer(GTGTherm1000));
